module.exports = __webpack_public_path__ + "img/1-gallery.0f1677f2.jpg";